import { ContactMessage, Model } from "@lumora/core";

/** Distinct subject tag so free sample requests are filterable in the contact inbox. */
export const SAMPLE_SUBJECT_TAG = "[FREE-SAMPLE]";

export interface SampleRequestInit {
  name: string;
  email: string;
  productUrl: string;
  category: string;
  photoUrl1: string;
  photoUrl2: string;
}

function isHttpUrl(v: string): boolean {
  try {
    const u = new URL(v.trim());
    return u.protocol === "https:" || u.protocol === "http:";
  } catch {
    return false;
  }
}

/** A seller's free sample request: product link, category and two photo links. No uploads. */
export class SampleRequest extends Model {
  name: string;
  email: string;
  productUrl: string;
  category: string;
  photoUrl1: string;
  photoUrl2: string;

  constructor(init: SampleRequestInit) {
    super();
    this.name = init.name;
    this.email = init.email;
    this.productUrl = init.productUrl;
    this.category = init.category;
    this.photoUrl1 = init.photoUrl1;
    this.photoUrl2 = init.photoUrl2;
  }

  toMessageBody(): string {
    return [
      `${SAMPLE_SUBJECT_TAG} Free sample request`,
      `Category: ${this.category}`,
      `Product link: ${this.productUrl.trim()}`,
      `Photo 1: ${this.photoUrl1.trim()}`,
      `Photo 2: ${this.photoUrl2.trim()}`,
    ].join("\n");
  }

  toContactMessage(): ContactMessage {
    return new ContactMessage(this.name, this.email, this.toMessageBody());
  }

  validate(): string[] {
    const errors: string[] = [];
    if (this.category === "") errors.push("Choose a product category.");
    if (!isHttpUrl(this.productUrl)) errors.push("Enter a product link starting with http:// or https://.");
    if (!isHttpUrl(this.photoUrl1)) errors.push("Enter a link for photo 1 (http:// or https://).");
    if (!isHttpUrl(this.photoUrl2)) errors.push("Enter a link for photo 2 (http:// or https://).");
    errors.push(...new ContactMessage(this.name, this.email, this.toMessageBody()).validate());
    return errors;
  }
}
